export default __webpack_public_path__ + "static/media/airstrapz-wht-banner-2.2bb3c55d.jpg";